export default {
  skills: []
}